angular.module('impactx.invoice').service('InvoiceDialogService', [
    'dataGen',
    'ConfirmationService',
    'TranslationService',
    'ToastService',
    'BackService',
    '$route',
    '$mdDialog',
    InvoiceDialogService
]);

function InvoiceDialogService(dataGen, ConfirmationService, TranslationService, ToastService, BackService, $route, $mdDialog) {
    var self = this;

    this.deactivate = function (event, blhId, question, toastMessage, reload) {
        ConfirmationService.showConfirmationDialog(function () {
            dataGen.postAsForm({}, {id: blhId}, "/invoice/deactivate").then(function () {
                if(reload)
                {
                    $route.reload();
                }
                else
                {
                    BackService.back();
                }
                ToastService.openStandardToast(toastMessage);
            });
        }, event, question, TranslationService.get('ok'), TranslationService.get('abort'));
    };

    this.reactivate = function (event, blhId, question, toastMessage) {
        ConfirmationService.showConfirmationDialog(function () {
            dataGen.postAsForm({}, {id: blhId}, "/invoice/reactivate").then(function () {
                BackService.back();
                ToastService.openStandardToast(toastMessage);
            });
        }, event, question, TranslationService.get('ok'), TranslationService.get('abort'));
    };

    this.deactivateItems = function (event, blhId, items, question, toastMessage, reloadFunc) {
        ConfirmationService.showConfirmationDialog(function () {
            dataGen.postAsForm({}, {blhId: blhId, items: items}, "/invoice/deactivate/items").then(function () {
                if(reloadFunc) {
                    reloadFunc();
                }
                ToastService.openStandardToast(toastMessage);
            });
        }, event, question, TranslationService.get('ok'), TranslationService.get('abort'));
    };

    this.reactivateItems = function (event, blhId, items, question, toastMessage, reloadFunc) {
        ConfirmationService.showConfirmationDialog(function () {
            dataGen.postAsForm({}, {blhId: blhId, items: items}, "/invoice/reactivate/items").then(function () {
                if(reloadFunc) {
                    reloadFunc();
                }
                ToastService.openStandardToast(toastMessage);
            });
        }, event, question, TranslationService.get('ok'), TranslationService.get('abort'));
    };

    this.showCompleteComplaintDialog = function (event, blhId) {
        return $mdDialog.show({
            controller: "InvoiceComplaintDialog",
            controllerAs: "ctrl",
            templateUrl: "modules/invoice/templates/invoice-complaint-dialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                blhId: blhId,
                viewPath: '/invoice/complaint/complete/view',
                savePath: '/invoice/complaint/complete/save',
            }
        });
    };

    this.showHeaderComplaintDialog = function (event, blhId) {
        return $mdDialog.show({
            controller: "InvoiceComplaintDialog",
            controllerAs: "ctrl",
            templateUrl: "modules/invoice/templates/invoice-complaint-dialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                blhId: blhId,
                viewPath: '/invoice/complaint/header/view',
                savePath: '/invoice/complaint/header/save',
            }
        });
    };

    this.showItemComplaintDialog = function (event, blhId, refId, refType, item) {
        return $mdDialog.show({
            controller: "InvoiceItemComplaintDialog",
            controllerAs: "ctrl",
            templateUrl: "modules/invoice/templates/invoice-item-complaint-dialog.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                blhId: blhId,
                refId: refId,
                refType: refType,
                item: item,
            }
        });
    };

    this.showComplaintDelete = function (event, blhId, question) {
        return ConfirmationService.showConfirmationDialogNoCallBack(event, question, TranslationService.get('ok'), TranslationService.get('abort')).then(function () {
            return dataGen.postAsForm({}, {id: blhId}, "/invoice/complaint/delete");
        });
    };

    this.showComplaintItemDelete = function (event, iciId, question) {
        return ConfirmationService.showConfirmationDialogNoCallBack(event, question, TranslationService.get('ok'), TranslationService.get('abort')).then(function () {
            return dataGen.postAsForm({}, {id: iciId}, "/invoice/complaint/item/delete");
        });
    };

    this.showCorrectionNewItemDialog = function (event, blhId, pdneId) {
        return $mdDialog.show({
            controller: "InvoiceCorrectionNewItemCtrl",
            controllerAs: "ctrl",
            templateUrl: "modules/invoice/templates/invoice-correction-newitem.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                blhId: blhId,
                pdneId: pdneId,
                copyId: 0,
                copyType: undefined,
                createCopy: false
            }
        });
    };

    this.showCorrectionNewItemDialogCopy = function (event, blhId, id, type) {
        return $mdDialog.show({
            controller: "InvoiceCorrectionNewItemCtrl",
            controllerAs: "ctrl",
            templateUrl: "modules/invoice/templates/invoice-correction-newitem.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                blhId: blhId,
                pdneId: 0,
                copyId: id,
                copyType: type,
                createCopy: true
            }
        });
    };

    this.showCorrectionEditItemDialog = function (event, blhId, dniId, item) {
        return $mdDialog.show({
            controller: "InvoiceCorrectionEditItemCtrl",
            controllerAs: "ctrl",
            templateUrl: "modules/invoice/templates/invoice-correction-edititem.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                blhId: blhId,
                dniId: dniId,
                source: item
            }
        });
    }

    this.showEditItemsDialog = function (event, blhId, items) {
        return $mdDialog.show({
            controller: "InvoiceEditItemsCtrl",
            controllerAs: "ctrl",
            templateUrl: "modules/invoice/templates/invoice-edit-items-dialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                blhId: blhId,
                items: items
            }
        });
    }

    return {
        deactivate: self.deactivate,
        reactivate: self.reactivate,
        deactivateItems: self.deactivateItems,
        reactivateItems: self.reactivateItems,
        showCompleteComplaintDialog: self.showCompleteComplaintDialog,
        showHeaderComplaintDialog: self.showHeaderComplaintDialog,
        showItemComplaintDialog: self.showItemComplaintDialog,
        showComplaintDelete: self.showComplaintDelete,
        showComplaintItemDelete: self.showComplaintItemDelete,
        showCorrectionNewItemDialog: self.showCorrectionNewItemDialog,
        showCorrectionNewItemDialogCopy: self.showCorrectionNewItemDialogCopy,
        showCorrectionEditItemDialog: self.showCorrectionEditItemDialog,
        showEditItemsDialog: self.showEditItemsDialog
    };
}